<template>
  <router-link
    v-if="params.customData && params.customData.id"
    :to="route"
    :target="newTab ? '_blank' : ''"
    class="link"
  >
    <span v-if="params.customData.prefix">{{ params.customData.prefix }}</span>
    {{ params.customData.label }}
  </router-link>
  <span v-else-if="params.customData">{{ params.customData.label }}</span>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'LmGridEntityLink',

  computed: {
    route() {
      return {
        name: `${this.params.customData.routeName}`,
        params: { id: this.params.customData.id }
      }
    },

    newTab() {
      return this.params.customData.newTab
    }
  }
})
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.link {
  text-decoration none
  color $accent-colour

  &:hover {
    text-decoration underline
  }
}
</style>
